import React from 'react';
import { DepartmentDetailLayout } from '../../components';

export const DepartmentDetails = () => {
  return <DepartmentDetailLayout />;
};
